export default __webpack_public_path__ + "3ceee1220b6e52aa819c2bbec6301ee8.webp";